export default "__VITE_ASSET__CcOKda0N__"